/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * request of POST /prtimes_media_lists/join
 * @export
 * @interface PrtimesMediaListsJoinRequest
 */
export interface PrtimesMediaListsJoinRequest {
    /**
     * 結合するメディアリストのIDリスト
     * @type {Array<number>}
     * @memberof PrtimesMediaListsJoinRequest
     */
    mediaListIds: Array<number>;
}

export function PrtimesMediaListsJoinRequestFromJSON(json: any): PrtimesMediaListsJoinRequest {
    return PrtimesMediaListsJoinRequestFromJSONTyped(json, false);
}

export function PrtimesMediaListsJoinRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrtimesMediaListsJoinRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mediaListIds': json['media_list_ids'],
    };
}

export function PrtimesMediaListsJoinRequestToJSON(value?: PrtimesMediaListsJoinRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'media_list_ids': value.mediaListIds,
    };
}

